import { ShieldCheck } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import AIReadabilityBlock from "@/components/AIReadabilityBlock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/hooks/useLanguage";
import { immigrationContent } from "@/i18n/immigration-content";

const VAWAPetitions = () => {
  const { language } = useLanguage();
  const content = immigrationContent.vawa[language];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        {content.sections.map((section, idx) => (
          <div key={idx} className="mb-8">
            <h2 className="text-3xl font-bold mb-6">{section.title}</h2>
            <p className="text-xl text-muted-foreground mb-6">{section.content}</p>
            {section.items && (
              <ul className="list-disc pl-6 mb-6">
                {section.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            )}
          </div>
        ))}

        <h3 className="text-2xl font-bold mb-6">
          {language === 'en' ? 'Frequently Asked Questions' : language === 'es' ? 'Preguntas Frecuentes' : 'Câu Hỏi Thường Gặp'}
        </h3>
        <Accordion type="single" collapsible className="w-full">
          {content.faq.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  const aiKeyPoints = [
    "VAWA self-petition for abuse victims",
    "No need for abuser's knowledge or cooperation",
    "Protection for spouses, children, and parents of abusers",
    "Work authorization while case is pending",
    "Path to lawful permanent residence",
    "Confidentiality protections",
    "Deferred action and protection from deportation",
    "Waiver of inadmissibility grounds"
  ];

  const aiFaqs = content.faq.map(f => ({ question: f.question, answer: f.answer }));

  return (
    <>
      <AIReadabilityBlock
        serviceName="VAWA Self-Petition Services"
        serviceDescription="Compassionate VAWA attorney in Houston helping abuse victims self-petition for immigration relief without their abuser's knowledge, including work authorization and path to green card."
        keyPoints={aiKeyPoints}
        faqs={aiFaqs}
        areaServed="Houston, Texas"
      />
      <GenericPracticePage
        title={content.title}
        subtitle={content.subtitle}
        icon={<ShieldCheck className="h-20 w-20 mx-auto mb-6 text-accent" />}
        mainContent={mainContent}
      />
    </>
  );
};

export default VAWAPetitions;
